import axios from "axios";
import { Status } from "../models/status";
import { Event } from "../models/event";

class NotificationWebservice {

    public async send(event:Event) {
        return await axios.post('/notification/send', {
            text: event.text,
            status_id: event.status.id
        }).then(function (response) {
            console.log('Successful sent the notification')
        }).catch(function (error) {
            console.log('Error happened during sending the notification: ' + error)
        })
    }
}

export const notificationWebservice = new NotificationWebservice();


// WEBPACK FOOTER //
// ./src/webservices/notification.ts